module.exports = __webpack_public_path__ + "img/language_icon_v2.481bd684.svg";